import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import instanceAPI from '../config/axiosconfig';

export const getAuctions = createAsyncThunk(
  'auctions/getAuctions',
  async () => {
    const auctions = await instanceAPI.get('/get-active-upcoming-auctions')
      .then((resp) => resp.data.auctions);
    return auctions;
  },
);

const auctionsSlice = createSlice({
  name: 'auctions',
  initialState: {
    auctions: [],
    status: null,
  },
  extraReducers: {
    [getAuctions.pending]: (state) => {
      state.status = 'loading';
    },
    [getAuctions.fulfilled]: (state, action) => {
      state.status = 'success';
      state.auctions = action.payload;
    },
    [getAuctions.rejected]: (state) => {
      state.status = 'failed';
    },
  },
});

export default auctionsSlice.reducer;
